module.exports = __webpack_public_path__ + "5f97fbe7ab7af64a666a56196b664cca.fbx";